<template>
  <section v-if="product.type === 'AndroidGame'" class="mt-5" itemscope itemtype="http://schema.org/MobileApplication">
    <h4>{{ $t('product.androidVersion', {product: this.globalResources.productTranslation.Single}) }}</h4>
    <b-badge variant="light" itemprop="version">
      {{ product.androidVersion }}
    </b-badge>
  </section>
</template>

<script>
export default {
  name: 'ProductAndroidVersion',
  props: {
    product: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
